<template>
  <div class="mb-6">
    <v-subheader>
      <v-icon v-if="icon" class="mr-2">{{ icon }}</v-icon>
      {{ sectionTitle }}
    </v-subheader>
    <v-divider></v-divider>
    <v-row>
      <v-col cols="12" sm="6" md="4" lg="3" xl="2" v-for="context in contexts" :key="context.id">
        <drag :data="context">
          <context-card :context="context">
            <template v-slot:title>{{ context.text }}</template>
            <template v-slot:subtitle>
              <v-card-subtitle v-if="showFolderName" class="py-0">
                <span>{{ context.folderName }}</span>
              </v-card-subtitle>
              <v-card-subtitle class="pt-0">
                <span>{{ context.lastOpened | fromNow }}</span>
              </v-card-subtitle>
            </template>
          </context-card>
        </drag>
      </v-col>
      <v-col cols="2" v-if="showCreateNew">
        <new-context-card :folderId="folderId"></new-context-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ContextCard from './ContextCard';
import NewContextCard from './NewContextCard';
import { Drag } from 'vue-easy-dnd';

export default {
  components: { ContextCard, NewContextCard, Drag },
  props: {
    sectionTitle: {
      default: 'Contexts'
    },
    showCreateNew: {
      default: true
    },
    showFolderName: {
      default: false,
      type: Boolean
    },
    contexts: {
      default: () => ({})
    },
    icon: {
      default: false
    },
    folderId: {}
  }
};
</script>

<style scoped>
.drag-source {
  pointer-events: none;
}
</style>
